// ============================================================================
// LES COORDONNÉES DU MAGASIN — son téléphone et son e-mail de contact.
//
// UTILITÉ : ce que le client voit du POINT DE VENTE (≠ la société) : la fiche Magasin du siège les montre, et la
// caisse les imprimera sous l'adresse du ticket. Le siège les saisit ; la caisse les lira.
//
// ⚠️ IL VIT DANS LE CONTRAT parce que deux écrivains doivent accepter la MÊME valeur : le descripteur des réglages
//    (back-office) et, demain, la saisie en caisse. Une règle écrite de chaque côté divergerait au premier correctif.
// ⚠️ LE TÉLÉPHONE S'ENREGISTRE EN E.164 (« +33389412207 ») et se lit groupé (`formatPhoneForDisplay`) : une seule forme
//    en base, quel que soit ce qu'on a tapé. L'écran convertit avant d'envoyer ; ce module refuse ce qui ne l'est pas.
// ============================================================================
import { isCanonicalPhone } from '@orgazone/core-crm';
import { isEmailAddress } from './supplier-terms';

/** Le téléphone du magasin, au format international. */
export const STORE_PHONE_SETTING = 'store.phone';

/** L'adresse e-mail publique du magasin — distincte du compte qui envoie ses courriers. */
export const STORE_EMAIL_SETTING = 'store.email';

/**
 * CE QUE VAUT LA VALEUR D'UNE COORDONNÉE — `null` si elle peut s'écrire, sinon le motif du refus.
 * ⚠️ VIDE EST PERMIS : retirer un numéro est un geste. Tout autre réglage passe (`null`).
 */
export function storeContactValueProblem(name: string, value: string): string | null {
  if (value === '') return null;
  if (name === STORE_PHONE_SETTING) {
    return isCanonicalPhone(value) ? null : `« ${value} » n’est pas un numéro au format international (+33…)`;
  }
  if (name === STORE_EMAIL_SETTING) {
    return value === value.trim() && isEmailAddress(value) ? null : `« ${value} » n’est pas une adresse e-mail`;
  }
  return null;
}
